<template>
  <v-dialog v-model="visible" max-width="600px">
    <v-card>
      <v-toolbar color="#f9f9f9">
        <v-toolbar-title>投保须知及声明</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="visible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text>
        <h3>保险经纪委托协议</h3>
        <p>甲方：同投保人</p>
        <p>乙方：易才宏业保险经纪有限公司</p>
        <p>第一条 甲方委托乙方作为保险经纪人, 协助甲方处理保险相关事宜。</p>
        <p>第二条 委托及服务具体事项如下：</p>
        <ul style="list-style-type:decimal">
          <li>协助甲方办理各项保险投保工作；</li>
          <li>为甲方提供保险期间的保险咨询；</li>
          <li>协助甲方处理保险期内保险索赔事宜。</li>
        </ul>
        <p></p>
        <p>第三条 本协议自投保人电子保单提交之日或在本投保单上签章之日起生效，协议终止日期同保险单中所载明的保险止期。</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  }
};
</script>

<style>
</style>
